<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Confirmação do pagamento</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para análise de pagamento.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="">
            <div class="box-order">
              <app-order-data
                [boobleModalData]="boobleModalData"
                [rType]="rType"
                [commercial]="commercial"
                [ir]="ir"
                [iof]="iof"
                [currency]="currency"
                [showDocuments]="true"
              ></app-order-data>
            </div>

            <div
              *ngIf="boobleModalData.orderAttachments.length > 0"
              class="div-documents"
            >
              <h3 class="title-generic mg-bottom-24 mg-top-8">
                Documentos anexados
              </h3>
              <div
                *ngFor="
                  let attachment of boobleModalData.orderAttachments;
                  let i = index
                "
              >
                <div class="document-and-icon">
                  <div id="document-name">
                    <img src="assets/image/clip-icon.svg" />

                    <p [title]="attachmentFileName(attachment.fileName)">
                      {{ attachmentFileName(attachment.fileName) }}
                    </p>

                    <!-- <img src="assets/image/view-icon.svg" /> -->
                  </div>

                  <div
                    class="d-flex gap-8 tappable"
                    (click)="downloadAttachment(attachment)"
                  >
                    <span class="text-blue">Baixar</span>
                    <img src="assets/image/download-icon.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="boobleModalData?.remmitanceType == 'INBOUND'"
        class="modal-footer-new"
        [style.justify-content]="'space-between'"
      >
        <button
          class="flat-red"
          (click)="openPaymentReprovedInboundModal(this?.boobleModalData)"
          mat-button
        >
          <mat-icon>close</mat-icon>

          <span> Problema no pagamento </span>
        </button>

        <button class="flat-green" (click)="approvePaymentInbound()" mat-button>
          <mat-icon>check</mat-icon>
          <span> Confirmar pagamento </span>
        </button>
      </div>
      <div
        *ngIf="boobleModalData?.remmitanceType == 'OUTBOUND'"
        class="modal-footer-new"
        [style.justify-content]="'space-between'"
      >
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>

        <div class="d-flex gap-22">
          <button
            class="flat-red"
            (click)="openPaymentConfirmReprovedModal(this?.boobleModalData)"
            mat-button
          >
            <mat-icon>close</mat-icon>

            <span> Recusar </span>
          </button>

          <button
            class="flat-green"
            (click)="approvePaymentConfirm()"
            mat-button
          >
            <mat-icon>check</mat-icon>
            <span> Confirmar </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
